import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * SettingsRoute component - Only allows commercial and admin users to access settings
 */
const SettingsRoute = ({ children }) => {
  const { user } = useAuth();
  
  // Check if user has permission to access settings
  const hasSettingsAccess = user && (
    ['commercial_manager', 'commercial_staff'].includes(user.role) || 
    user.role === 'admin' || 
    user.role === 'Director'
  );
  
  if (!hasSettingsAccess) {
    // Redirect to dashboard if user doesn't have access
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

export default SettingsRoute;